module.exports = __webpack_public_path__ + "static/media/crown-gold.5a033b41.svg";